// Internal modules
import { features } from '@/lib/features';

export const getSubFlowForPaymentHeader = isGuestFlow => {
  if (features.isActive('isDonation')) {
    return 'donation';
  }

  if (features.isActive('shouldUseUlHeadings')) {
    return isGuestFlow ? 'ulOptional' : 'ulForced';
  }

  return 'base';
};
